import { Command, Query } from '../common'
import { CancelToken } from '@/app/shared/utils'

export const TrackingService2Symbol = Symbol.for('TrackingService2')

export interface TrackingService2 {
  execute(command: Command): void
  query<T extends string, TPayload, TResult>(query: Query<T, TPayload, TResult>, cancel?: CancelToken): Promise<TResult>
}
